<template>
  <custom-btn-dialog
    btn-text="Affectation"
    width="70vw"
    color="primary"
    v-bind="$attrs"
    icon="search"
    ref="dialog"
    :disabled="disabled"
    title="Recherche"
  >
    <template v-slot:activator="{ click }">
      <v-select
        v-bind="$attrs"
        :value="value"
        :loading="loading"
        :items="items"
        @input="handleInputChange"
        :multiple="multiple"
        item-value="id"
        append-icon="mdi-plus"
        v-on:click:append="click"
        color="success"
        readonly
        outlined
        dense
      >
        <template v-slot:selection="{ selected, item }">
          <v-chip
            :value="selected"
            close
            @click:close="handleInputRemove(item)"
          >
            {{ item | displayTechName }}
          </v-chip>
        </template>
      </v-select>
    </template>
    <template v-slot:actions>
      <v-btn class="mx-2" small @click="cancel">
        {{ generateMessage('tech_search.cancel') }}
      </v-btn>
    </template>
    <template v-slot:default>
      <custom-technician-selector-table
        :entity-id="entityId"
        :property-id="propertyId"
        module-path="actions/technicians"
        :selection="true"
        @input="handleAssignClick"
      />
    </template>
  </custom-btn-dialog>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import CustomBtnDialog from '@/components/dialogs/CustomBtnDialog';
import CustomTechnicianSelectorTable from '@/components/selects/technician/CustomTechnicianSelectorTable';
import createReusableBaseModule from '@/store/reusableBaseModule';
import createTechnicianSimpleRequest from '@/components/selects/technician/technicianReusableBaseRequest';
import Maths from '@/business/utils/maths';
import TechniciansService from '@/services/services/technicians.service';

export default {
  name: 'TechnicianSelectionDialog',
  components: {
    CustomTechnicianSelectorTable,
    CustomBtnDialog,
  },
  props: {
    value: { type: [Array, Number], required: false },
    entityId: { type: String, required: false },
    propertyId: { type: Number, required: false },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, required: false },
  },
  filters: {
    displayTechName(tech) {
      return tech && tech.first_name && `${tech.first_name} ${tech.last_name}`;
    },
  },
  methods: {
    generateMessage,
    handleInputChange(val) {
      this.$emit('input', val);
      if (this.multiple) {
        this.$emit('affectedTech', Maths.arrayRetainsIdx(this.items, val));
      } else {
        this.$emit(
          'affectedTech',
          this.items.find((item) => item.id === val)
        );
      }
    },
    cancel() {
      this.$refs.dialog.handleCloseClick();
    },
    handleAssignClick(item) {
      if (this.multiple) {
        const newVals = [...this.value];
        newVals.push(item.id);
        this.handleInputChange(newVals);
      } else {
        this.handleInputChange(item.id);
      }
      this.cancel();
    },
    handleInputRemove(item) {
      if (this.multiple) {
        this.handleInputChange(this.value.filter((id) => id !== item.id));
      } else {
        this.handleInputChange(null);
      }
    },
    initValue() {
      if (this.multiple) {
        if (this.value.length > 0) {
          this.$store.dispatch(`${this.module.path}/searchByIdx`, this.value);
        }
      } else if (this.value) {
        this.$store.dispatch(`${this.module.path}/searchByIdx`, [this.value]);
      }
    },
  },
  created() {
    const { names, path } = createReusableBaseModule({
      store: this.$store,
      // eslint-disable-next-line no-underscore-dangle
      name: `${this.$options.name}/${this._uid}`,
      serviceAPI: TechniciansService,
      makeQueryParams: createTechnicianSimpleRequest({
        idField: 'id',
        searchAttributesArray: ['id', 'user_gid'],
      }),
    });
    this.module.names = names;
    this.module.path = path;
    this.initValue();
  },
  data() {
    return {
      module: {},
    };
  },
  watch: {
    value() {
      this.initValue();
    },
  },
  computed: {
    groupId() {
      return this.$store.getters['global/groupId'];
    },
    items() {
      const items = this.$store.getters[`actions/technicians/items`].concat(
        this.$store.getters[`${this.module.path}/items`]
      );
      this.$emit('affectedTech', Maths.arrayRetainsIdx(items, this.value));
      return items;
    },
    loading() {
      return this.$store.getters[`${this.module.path}/isLoadingItems`];
    },
  },
  beforeDestroy() {
    // Unregister the dynamically created module
    this.$store.unregisterModule(this.module.names);
  },
};
</script>
